// extracted by mini-css-extract-plugin
export default {"profile-icon":"image_profile-icon__xcm0V","profile-name":"image_profile-name__8jAd4","content":"image_content__8qD+w"};